import { useRef, useEffect, useState } from 'react'
import { useWindowSize } from 'react-use'

const useElementSize = () => {
  const [elementSize, setElementSize] = useState({ width: 0, height: 0 })
  const { width, height } = useWindowSize()
  const elRef = useRef()

  useEffect(() => {
    if (elRef.current) {
      const elRect = elRef.current.getBoundingClientRect()
      setElementSize({ width: elRect.width, height: elRect.height })
    }
  }, [width, height, setElementSize])

  return [elRef, elementSize]
}

export default useElementSize
